<template>
  <LoginPage />
</template>

<script>
import LoginPage from '@/templates/LoginPage.vue'

export default {
  components: {
    LoginPage
  },
  beforeDestroy() {
    document.body.className = "";
  },
  mounted() {
    document.body.className = "color";
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue